import React from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import Hero from "../components/homi/Hero";
import WhyChoose from "../components/homi/WhyChoose";
import Services from "../components/homi/Services";
import About from "../components/homi/About";
import Stats from "../components/homi/Stats";
import Features from "../components/homi/Features";
import Projects from "../components/homi/Projects";
import Transformations from "../components/homi/Transformations";
import Faq from "../components/homi/Faq";
import BlogTeasers from "../components/homi/BlogTeasers";
import ContactCta from "../components/homi/ContactCta";

export default function HomiPage() {
  return (
    <div className="App bg-white">
      <SiteHeader />
      <main>
        <Hero />
        <WhyChoose />
        <Services />
        <About />
        <Stats />
        <Features />
        <Projects />
        <Transformations />
        <Faq />
        <BlogTeasers />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}
